// extracted by mini-css-extract-plugin
export default {"marginInputBottom":"Deposit_marginInputBottom__XVRgB","amountInputMargin":"Deposit_amountInputMargin__uY7zz"};